import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4586cc22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-list" }
const _hoisted_2 = { class: "collection-list-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DetailTitle, {
        title: "催收记录",
        collapse: _ctx.collapse,
        onCollapse: _ctx.onCollapseChange
      }, null, 8, ["collapse", "onCollapse"]),
      (!_ctx.collapse)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.onBuild
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              style: {"margin-left":"16px"},
              type: "default",
              onClick: _ctx.startPaymentProcess
            }, {
              default: _withCtx(() => [
                _createTextVNode("发起回款流程")
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 512)), [
            [_vShow, !_ctx.unOperate]
          ])
        : _createCommentVNode("", true)
    ]),
    (!_ctx.collapse)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_a_radio_group, {
            value: _ctx.menu.current,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menu.current) = $event)),
            disabled: _ctx.operate,
            onChange: _ctx.loadData,
            style: {"margin-bottom":"16px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.list, (val, index) => {
                return (_openBlock(), _createBlock(_component_a_radio_button, {
                  key: index,
                  value: val.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(val.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "disabled", "onChange"])
        ], 512)), [
          [_vShow, !_ctx.collapse]
        ])
      : _createCommentVNode("", true),
    (!_ctx.collapse)
      ? (_openBlock(), _createBlock(_component_ListView, {
          key: 1,
          ref: "list-view",
          "complex-list": _ctx.mainData,
          option: _ctx.listOption,
          onMenu: _ctx.onMenu
        }, null, 8, ["complex-list", "option", "onMenu"]))
      : _createCommentVNode("", true)
  ]))
}